import { CloudDownload as DownloadIcon } from "@mui/icons-material";
import { Fab as FloatingActionButton } from "@mui/material";
import type { FC } from "react";
import { useMemo } from "react";
import { CSVLink } from "react-csv";
import type { Cost } from "./costTypes";
import { costsToCsv } from "./costsToCsv";

interface Props {
  values: Cost[];
}

const CostsCsvExport: FC<Props> = ({ values }) => {
  const data = useMemo(() => {
    return costsToCsv(values);
  }, [values]);

  return (
    <CSVLink data={data} target="_blank" filename="koszty.csv">
      <FloatingActionButton color="secondary" title="CSV z kosztami">
        <DownloadIcon />
      </FloatingActionButton>
    </CSVLink>
  );
};

export default CostsCsvExport;
